import { AdminLayout, DashboardPage } from '@/modules/shared';
import { DashboardCompanyPage } from '@/modules/client-portal';
import { useAuthStore } from '@/stores/auth'; 

// Route configuration for client/company section
const clientRoutes = [
  {
    path: '/clients',
    component: AdminLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: () => {
          // Usando Pinia em vez de window.$store
          const authStore = useAuthStore();
          const companyId = authStore.user?.companyId;
          console.log("redirect - companyId:", companyId);
          
          if (companyId) {
            return { name: 'company-statistics', params: { companyId } };
          }
          console.log("dando not-found em client-routes.js antes de ver algo mais");
          return { name: 'not-found' };
        }
      },
      {
        path: 'meuslinks',
        name: 'meuslinks',
        component: () => import('@/modules/client-portal/views/MyLinksPage.vue'),
        meta: {
          requiresAuth: true,
          // allowedRoles: ['company']
        }
      },
      {
        path: 'dashboard',
        name: 'company-dashboard',
        component: DashboardPage
      },
      {
        path: 'statistics/:companyId',
        name: 'company-statistics',
        component: () => import('@/modules/client-portal/views/DashboardCompanyPage.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
          console.log("company-statistics beforeEnter - início");
          
          // Usando Pinia em vez de window.$store
          const authStore = useAuthStore();
          const userCompanyId = String(authStore.user?.companyId || '');
          const requestedCompanyId = String(to.params.companyId || '');
          
          console.log("company-statistics beforeEnter:", {
            userCompanyId,
            requestedCompanyId,
            usuário: authStore.user,
            isMatch: userCompanyId === requestedCompanyId
          });
          
          if (!userCompanyId || userCompanyId !== requestedCompanyId) {
            console.log("Acesso negado: ID da empresa não corresponde");
            next({ name: 'not-found' });
            return;
          }
          
          console.log("Acesso permitido para company-statistics");
          next();
        }
      },
      {
        path: 'branches',
        name: 'company-branches',
        component: () => import('@/components/company/BranchManager.vue'),
        props: () => {
          // Usando Pinia em vez de window.$store
          const authStore = useAuthStore();
          return { id: authStore.user?.companyId };
        }
      },
      {
        path: 'branches/:branchId',
        name: 'company-branch-edit',
        component: () => import('@/components/company/BranchForm.vue'),
        props: route => {
          // Usando Pinia em vez de window.$store
          const authStore = useAuthStore();
          return {
            companyId: authStore.user?.companyId,
            branchId: route.params.branchId
          };
        }
      },
      {
        path: 'preferences',
        name: 'company-preferences',
        component: () => import('@/components/company/PreferencesForm.vue'),
        props: () => {
          // Usando Pinia em vez de window.$store
          const authStore = useAuthStore();
          return { id: authStore.user?.companyId };
        }
      },
      
      // Novas rotas para o sistema de assinaturas (Cliente)
      // {
      //   path: 'subscription',
      //   name: 'client-subscription',
      //   component: () => import('@/modules/client-portal/views/ClientSubscriptionDetails.vue'),
      //   props: () => {
      //     const authStore = useAuthStore();
      //     return { 
      //       userId: authStore.user?.id,
      //       companyId: authStore.user?.companyId 
      //     };
      //   }
      // },
      // {
      //   path: 'subscription/history',
      //   name: 'client-subscription-history',
      //   component: () => import('@/modules/client-portal/views/ClientSubscriptionHistory.vue'),
      //   props: () => {
      //     const authStore = useAuthStore();
      //     return { 
      //       userId: authStore.user?.id,
      //       companyId: authStore.user?.companyId 
      //     };
      //   }
      // },
      // {
      //   path: 'subscription/change-plan',
      //   name: 'client-subscription-change-plan',
      //   component: () => import('@/modules/client-portal/views/ClientChangePlan.vue'),
      //   props: () => {
      //     const authStore = useAuthStore();
      //     return { 
      //       userId: authStore.user?.id,
      //       companyId: authStore.user?.companyId 
      //     };
      //   }
      // }
    ]
  }
];

export default clientRoutes;